import React, {Component, PropTypes} from 'react';
import { translate as t } from 'lang';
import classNames from 'classnames';
import {uniqueId} from 'lodash';
import ReactTelephoneInput from 'react-telephone-input/lib/withStyles';
import config from '../../../configs/application';

import './TelControl.scss';

const SIZE = ['small', 'large'];
const LABEL_SIZE = ['small', 'normal'];
const FLAG_PATH = config.static.root + '/images/flags.png';
const DEFAULT_COUNTRY = 'ru';

class TelControl extends Component {

    static propTypes = {
        value: PropTypes.string,
        label: PropTypes.string,
        placeholder: PropTypes.string,
        size: PropTypes.oneOf(SIZE),
        onChange: PropTypes.func,
        id: PropTypes.string,
        disabled: PropTypes.bool,
        success: PropTypes.bool,
        error: PropTypes.string,
        labelSize: PropTypes.oneOf(LABEL_SIZE),
        required: PropTypes.bool,
        isIsraelModeOn: PropTypes.bool,
    }

    static defaultProps = {
        id: uniqueId(),
        required: false,
        error: '',
        label_size: 'normal',
        isIsraelModeOn: false,
    }

    constructor(props) {
        super(props);
        this.state = {
            filled: false,
        };
    }

    _onChange = (telNumber, event) => {
        if (this.props.onChange) {
            this.props.onChange(event, telNumber);
        }
    }

    render() {
        var {className, ...props} = this.props;
        className = classNames(
            'TelControl',
            {
                'TelControl--multiline': props.multiline,
                [`TelControl--${props.size}`]: props.size,
                '-success': props.success,
                '-error': props.error,
            },
            className
        );

        var telClassName;
        telClassName = classNames(
            'TelControl-control',
            telClassName
        );

        var TelControl = (
            <ReactTelephoneInput {...props}
                className={telClassName}
                value={props.value}
                placeholder={props.placeholder}
                onChange={this._onChange}
                defaultCountry={this.props.isIsraelModeOn ? 'il' : DEFAULT_COUNTRY}
                flagsImagePath={FLAG_PATH} />
        );

        var errorMessage;
        if (props.error) {
            errorMessage = (
                <div className="TelControl-error">
                    {t(props.error)}
                </div>
            );
        }


        if (props.label) {

            var star = '';
            if (props.required) {
                star = (<span className="TelControl-label-required">*</span>);
            }

            var label = (
                <label className={classNames([
                                    'TelControl-label',
                                    'TelControl-label--' + this.props.labelSize,
                                ])}
                    htmlFor={props.id}>
                    {props.label} {star}
                </label>
            );
        }

        return (
            <div className={className}>
                {label}
                {TelControl}
                {errorMessage}
            </div>
        );
    }

}

export default TelControl;



// WEBPACK FOOTER //
// ./client/components/TelControl/TelControl.js